var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEquals = function SvgEquals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.506 7h5.037c1.942 0 1.942 3 0 3H1.456c-1.941 0-1.941-3 0-3h8.05ZM9.506 0h5.037c1.942 0 1.942 3 0 3H1.456c-1.941 0-1.941-3 0-3h8.05Z",
    fill: "#365063"
  })));
};

export { SvgEquals as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxNiAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuNTA2MDkgN0gxNC41NDM0QzE2LjQ4NTUgNyAxNi40ODU1IDEwIDE0LjU0MzQgMTBIOS41MDYwOUgxLjQ1NjQ0Qy0wLjQ4NTQ3OSAxMCAtMC40ODU0NzkgNyAxLjQ1NjQ0IDdIOS41MDYwOVoiIGZpbGw9IiMzNjUwNjMiLz4KPHBhdGggZD0iTTkuNTA2MDkgMEgxNC41NDM0QzE2LjQ4NTUgMCAxNi40ODU1IDMgMTQuNTQzNCAzSDkuNTA2MDlIMS40NTY0NEMtMC40ODU0NzkgMyAtMC40ODU0NzkgMCAxLjQ1NjQ0IDBIOS41MDYwOVoiIGZpbGw9IiMzNjUwNjMiLz4KPC9zdmc+Cg==";